import { useEffect } from 'react'
import { ZoomMtg } from '@zoom/meetingsdk'
import { setupCustomUI, handleJoinSuccess } from '../services/zoom-ui-service'

interface ZoomMeetingInitializerProps {
  token: string
  brand: string
  language: string
  startDate: string
  endDate: string
  meetingNumber: string
  passWord: string
  userRole: number
}

const ZoomMeetingInitializer = ({
  token,
  brand,
  language,
  startDate,
  endDate,
  meetingNumber,
  passWord,
  userRole,
}: ZoomMeetingInitializerProps) => {
  const sdkKey = 'wku6X1VQBSGsA_WkHMO_Q'

  const userName = userRole === 0 ? 'Cliente' : userRole === 1 ? 'Orientadora Personal' : 'User'

  const userEmail = 'qida@qida.com'
  const leaveUrl = `${window.location.origin}/zoom/meeting-ended/${token}?language=${language}&brand=${brand}`

  useEffect(() => {
    const startMeeting = (signature: string) => {
      ZoomMtg.preLoadWasm()
      ZoomMtg.prepareWebSDK()
      ZoomMtg.i18n.load('es-ES')
      ZoomMtg.i18n.reload('es-ES')

      document.documentElement.lang = 'es-ES'

      const zmmtgRoot = document.getElementById('zmmtg-root')
      if (!zmmtgRoot) {
        console.error("Element with ID 'zmmtg-root' not found.")
        return
      }
      zmmtgRoot.style.display = 'block'

      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
      const isSmallScreen = window.innerWidth < 768

      const waitingRoomObserver = new MutationObserver(() => {
        const waitingTexts = document.querySelectorAll('.waiting-info-text')
        waitingTexts.forEach((element) => {
          if (element.textContent?.includes('Waiting for the host')) {
            element.textContent =
              'Esperando a que el anfitrión inicie esta reunión'
          }
          if (element.textContent?.includes('Please wait')) {
            element.textContent =
              'Por favor, espere. El anfitrión le permitirá entrar pronto.'
          }
        })

        const buttons = document.querySelectorAll('button')
        buttons.forEach((button) => {
          if (button.textContent === 'Leave') {
            button.textContent = 'Salir'
          }
          if (button.textContent === 'Cancel') {
            button.textContent = 'Cancelar'
          }
        })
      })

      const recordingModalObserver = new MutationObserver(() => {
        const modalContents = document.querySelectorAll('.confirm-modal-content')
        modalContents.forEach((element) => {
          if (element.textContent?.includes('Anyone with access to the recording')) {
            element.textContent = 'Cualquier persona con acceso a la grabación puede verla o compartirla con otros.'
          }
        })
      })

      waitingRoomObserver.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
      })
      
      recordingModalObserver.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
      })

      ZoomMtg.init({
        leaveUrl: leaveUrl,
        patchJsMedia: true,
        leaveOnPageUnload: true,
        isSupportAV: true,
        ...(isMobile || isSmallScreen ? {} : { defaultView: 'gallery' }),
        success: (success: unknown) => {
          setupCustomUI(brand, startDate, endDate, language, token)

          ZoomMtg.join({
            signature: signature,
            sdkKey: sdkKey,
            meetingNumber: meetingNumber,
            passWord: passWord,
            userName: userName,
            userEmail: userEmail,
            success: (success: unknown) => {
              handleJoinSuccess(userRole, brand, language)
            },
            error: function (error: unknown) {
              console.error('ZoomMtg.join error:', error)
            },
          })
        },
        error: function (error: unknown) {
          console.error('ZoomMtg.init error:', error)
        },
      })
    }

    startMeeting(token)
  }, [
    token,
    brand,
    language,
    startDate,
    endDate,
    meetingNumber,
    passWord,
    userRole,
    leaveUrl,
  ])

  return null
}

export default ZoomMeetingInitializer
